import client from '@infinitro/global';
import { createCompatHelpers } from '@infinitro/global';
import gql from 'graphql-tag';
const { makeQueryStore, makeAsyncQuery, makeMutation, makeSubscription } = createCompatHelpers(client);
export var ActionEligibilityStatus;
(function (ActionEligibilityStatus) {
    ActionEligibilityStatus["ACCOUNT_AGE_REQUIRED"] = "ACCOUNT_AGE_REQUIRED";
    ActionEligibilityStatus["ADMIN_DISABLED"] = "ADMIN_DISABLED";
    ActionEligibilityStatus["DEPOSIT_REQUIRED"] = "DEPOSIT_REQUIRED";
    ActionEligibilityStatus["ELIGIBLE"] = "ELIGIBLE";
    ActionEligibilityStatus["ELIGIBLE_POST_REVIEWED"] = "ELIGIBLE_POST_REVIEWED";
    ActionEligibilityStatus["ELIGIBLE_WITH_APPROVAL"] = "ELIGIBLE_WITH_APPROVAL";
    ActionEligibilityStatus["GEO_DISABLED"] = "GEO_DISABLED";
    ActionEligibilityStatus["MOD_DISABLED"] = "MOD_DISABLED";
    ActionEligibilityStatus["OTHER"] = "OTHER";
    ActionEligibilityStatus["PLAYER_DISABLED"] = "PLAYER_DISABLED";
    ActionEligibilityStatus["PLAY_REQUIRED"] = "PLAY_REQUIRED";
    ActionEligibilityStatus["SYSTEM_DISABLED"] = "SYSTEM_DISABLED";
})(ActionEligibilityStatus || (ActionEligibilityStatus = {}));
export var ActionType;
(function (ActionType) {
    ActionType["ACTIVE_SESSION"] = "ACTIVE_SESSION";
    ActionType["ALERT"] = "ALERT";
    ActionType["ALL"] = "ALL";
    ActionType["ALL_BALANCE"] = "ALL_BALANCE";
    ActionType["ALL_SETTINGS"] = "ALL_SETTINGS";
    ActionType["ALL_WRITE"] = "ALL_WRITE";
    ActionType["APPROVE"] = "APPROVE";
    ActionType["AUDIT"] = "AUDIT";
    ActionType["BONUS"] = "BONUS";
    ActionType["BONUS_CLAIM"] = "BONUS_CLAIM";
    ActionType["CASINO_PLAY"] = "CASINO_PLAY";
    ActionType["CHANGE_DISPLAY_NAME"] = "CHANGE_DISPLAY_NAME";
    ActionType["CHANGE_EMAIL"] = "CHANGE_EMAIL";
    ActionType["CHANGE_WALLET_CONNECT"] = "CHANGE_WALLET_CONNECT";
    ActionType["CHAT"] = "CHAT";
    ActionType["CONFIRM"] = "CONFIRM";
    ActionType["CONNECT"] = "CONNECT";
    ActionType["CONNECT_CONFIRM"] = "CONNECT_CONFIRM";
    ActionType["CONNECT_START"] = "CONNECT_START";
    ActionType["DELETE"] = "DELETE";
    ActionType["DEMO_LAUNCH"] = "DEMO_LAUNCH";
    ActionType["DEPOSIT"] = "DEPOSIT";
    ActionType["DEPOSIT_BONUS"] = "DEPOSIT_BONUS";
    ActionType["DISABLE_WALLET_AUTH"] = "DISABLE_WALLET_AUTH";
    ActionType["EMAIL_VERIFY"] = "EMAIL_VERIFY";
    ActionType["ENABLE_WALLET_AUTH"] = "ENABLE_WALLET_AUTH";
    ActionType["EXPIRE"] = "EXPIRE";
    ActionType["FIRST_TIME_DEPOSIT_BONUS"] = "FIRST_TIME_DEPOSIT_BONUS";
    ActionType["GAME_LAUNCH"] = "GAME_LAUNCH";
    ActionType["GLOBAL"] = "GLOBAL";
    ActionType["GRANT"] = "GRANT";
    ActionType["IGNORE"] = "IGNORE";
    ActionType["LOCK"] = "LOCK";
    ActionType["LOGIN"] = "LOGIN";
    ActionType["NOTE"] = "NOTE";
    ActionType["OTHER"] = "OTHER";
    ActionType["OVERWRITE_REVIEWER"] = "OVERWRITE_REVIEWER";
    ActionType["PASS"] = "PASS";
    ActionType["PRE_LOGIN"] = "PRE_LOGIN";
    ActionType["RAIN"] = "RAIN";
    ActionType["READ"] = "READ";
    ActionType["REFER"] = "REFER";
    ActionType["REFRESH_SESSION"] = "REFRESH_SESSION";
    ActionType["REGISTER"] = "REGISTER";
    ActionType["REGISTER_NO_ASSOCIATED_DEPOSIT"] = "REGISTER_NO_ASSOCIATED_DEPOSIT";
    ActionType["REGISTER_UNASSOCIATED"] = "REGISTER_UNASSOCIATED";
    ActionType["REJECT"] = "REJECT";
    ActionType["RESET"] = "RESET";
    ActionType["REVIEW"] = "REVIEW";
    ActionType["REVOKE"] = "REVOKE";
    ActionType["REWARDS"] = "REWARDS";
    ActionType["REWARDS_CLAIM"] = "REWARDS_CLAIM";
    ActionType["SET_DISPLAY_NAME"] = "SET_DISPLAY_NAME";
    ActionType["SET_EMAIL"] = "SET_EMAIL";
    ActionType["SET_WALLET_CONNECT"] = "SET_WALLET_CONNECT";
    ActionType["SPORTS_BET"] = "SPORTS_BET";
    ActionType["SPORTS_LAUNCH"] = "SPORTS_LAUNCH";
    ActionType["SURVEY"] = "SURVEY";
    ActionType["TIP"] = "TIP";
    ActionType["TRIGGER"] = "TRIGGER";
    ActionType["UNLOCK"] = "UNLOCK";
    ActionType["VISIT"] = "VISIT";
    ActionType["VISIT_HARD"] = "VISIT_HARD";
    ActionType["VISIT_SESSION"] = "VISIT_SESSION";
    ActionType["VISIT_SOFT"] = "VISIT_SOFT";
    ActionType["WAIT"] = "WAIT";
    ActionType["WEBHOOK_BLOCKCYPHER"] = "WEBHOOK_BLOCKCYPHER";
    ActionType["WEBHOOK_MORALIS"] = "WEBHOOK_MORALIS";
    ActionType["WITHDRAW"] = "WITHDRAW";
    ActionType["WRITE"] = "WRITE";
})(ActionType || (ActionType = {}));
export var ActionTypeEnum;
(function (ActionTypeEnum) {
    ActionTypeEnum["BONUS_CLAIM"] = "BONUS_CLAIM";
    ActionTypeEnum["BUY_CRYPTO"] = "BUY_CRYPTO";
    ActionTypeEnum["DEPOSIT"] = "DEPOSIT";
    ActionTypeEnum["DEPOSIT_CRYPTO"] = "DEPOSIT_CRYPTO";
    ActionTypeEnum["DEPOSIT_FIAT"] = "DEPOSIT_FIAT";
    ActionTypeEnum["WITHDRAW"] = "WITHDRAW";
    ActionTypeEnum["WITHDRAW_CRYPTO"] = "WITHDRAW_CRYPTO";
    ActionTypeEnum["WITHDRAW_FIAT"] = "WITHDRAW_FIAT";
})(ActionTypeEnum || (ActionTypeEnum = {}));
export var AllowRequirement;
(function (AllowRequirement) {
    AllowRequirement["APPROVAL"] = "APPROVAL";
    AllowRequirement["BESPOKE"] = "BESPOKE";
    AllowRequirement["DEPOSIT"] = "DEPOSIT";
    AllowRequirement["EMAIL_CODE"] = "EMAIL_CODE";
    AllowRequirement["EMAIL_VERIFIED"] = "EMAIL_VERIFIED";
    AllowRequirement["INELIGIBLE_ACCOUNT"] = "INELIGIBLE_ACCOUNT";
    AllowRequirement["MIN_AGE"] = "MIN_AGE";
    AllowRequirement["MIN_DEPOSIT"] = "MIN_DEPOSIT";
    AllowRequirement["MIN_LEVEL"] = "MIN_LEVEL";
    AllowRequirement["OTHER"] = "OTHER";
    AllowRequirement["PLAY"] = "PLAY";
    AllowRequirement["SEEK_SUPPORT"] = "SEEK_SUPPORT";
    AllowRequirement["TWO_FACTOR_ALWAYS"] = "TWO_FACTOR_ALWAYS";
    AllowRequirement["TWO_FACTOR_IF_ENABLED"] = "TWO_FACTOR_IF_ENABLED";
})(AllowRequirement || (AllowRequirement = {}));
export var AllowStatus;
(function (AllowStatus) {
    AllowStatus["ALLOW"] = "ALLOW";
    AllowStatus["DENY"] = "DENY";
    AllowStatus["HOLD"] = "HOLD";
    AllowStatus["LIMIT"] = "LIMIT";
    AllowStatus["REQUIRE"] = "REQUIRE";
})(AllowStatus || (AllowStatus = {}));
export var BalanceStatus;
(function (BalanceStatus) {
    BalanceStatus["ACTIVE"] = "ACTIVE";
    BalanceStatus["CANCELLED"] = "CANCELLED";
    BalanceStatus["CASHED_OUT"] = "CASHED_OUT";
    BalanceStatus["CASHOUT_PENDING"] = "CASHOUT_PENDING";
    BalanceStatus["EXPIRED"] = "EXPIRED";
    BalanceStatus["FREEZE"] = "FREEZE";
    BalanceStatus["FREEZE_PLAY"] = "FREEZE_PLAY";
    BalanceStatus["FREEZE_QUALIFY"] = "FREEZE_QUALIFY";
    BalanceStatus["INACTIVE"] = "INACTIVE";
    BalanceStatus["NOT_FOUND"] = "NOT_FOUND";
    BalanceStatus["PENDING"] = "PENDING";
    BalanceStatus["QUALIFIED"] = "QUALIFIED";
    BalanceStatus["USED"] = "USED";
})(BalanceStatus || (BalanceStatus = {}));
export var CryptoToken;
(function (CryptoToken) {
    CryptoToken["bnb_bnb"] = "bnb_bnb";
    CryptoToken["bnb_usdt"] = "bnb_usdt";
    CryptoToken["btc_btc"] = "btc_btc";
    CryptoToken["doge_doge"] = "doge_doge";
    CryptoToken["eth_eth"] = "eth_eth";
    CryptoToken["eth_usdc"] = "eth_usdc";
    CryptoToken["eth_usdt"] = "eth_usdt";
    CryptoToken["invalid"] = "invalid";
    CryptoToken["ltc_ltc"] = "ltc_ltc";
    CryptoToken["other"] = "other";
    CryptoToken["polygon_matic"] = "polygon_matic";
    CryptoToken["polygon_pol"] = "polygon_pol";
    CryptoToken["polygon_usdc"] = "polygon_usdc";
    CryptoToken["polygon_usdt"] = "polygon_usdt";
    CryptoToken["solana_sol"] = "solana_sol";
    CryptoToken["solana_usdc"] = "solana_usdc";
    CryptoToken["solana_usdt"] = "solana_usdt";
    CryptoToken["tron_trx"] = "tron_trx";
    CryptoToken["tron_usdt"] = "tron_usdt";
})(CryptoToken || (CryptoToken = {}));
export var Currency;
(function (Currency) {
    Currency["aud"] = "aud";
    Currency["bnb"] = "bnb";
    Currency["btc"] = "btc";
    Currency["cad"] = "cad";
    Currency["dai"] = "dai";
    Currency["doge"] = "doge";
    Currency["eth"] = "eth";
    Currency["eur"] = "eur";
    Currency["gbp"] = "gbp";
    Currency["jpy"] = "jpy";
    Currency["ltc"] = "ltc";
    Currency["matic"] = "matic";
    Currency["mnt"] = "mnt";
    Currency["near"] = "near";
    Currency["other"] = "other";
    Currency["pol"] = "pol";
    Currency["sol"] = "sol";
    Currency["trx"] = "trx";
    Currency["try"] = "try";
    Currency["usd"] = "usd";
    Currency["usdc"] = "usdc";
    Currency["usdt"] = "usdt";
})(Currency || (Currency = {}));
export var CurrencyAddressEnum;
(function (CurrencyAddressEnum) {
    CurrencyAddressEnum["bitcoin"] = "bitcoin";
    CurrencyAddressEnum["dogecoin"] = "dogecoin";
    CurrencyAddressEnum["evm"] = "evm";
    CurrencyAddressEnum["fiat"] = "fiat";
    CurrencyAddressEnum["interac"] = "interac";
    CurrencyAddressEnum["invalid"] = "invalid";
    CurrencyAddressEnum["lightning"] = "lightning";
    CurrencyAddressEnum["litecoin"] = "litecoin";
    CurrencyAddressEnum["near"] = "near";
    CurrencyAddressEnum["other"] = "other";
    CurrencyAddressEnum["solana"] = "solana";
    CurrencyAddressEnum["tron"] = "tron";
})(CurrencyAddressEnum || (CurrencyAddressEnum = {}));
export var CurrencyNetworkEnum;
(function (CurrencyNetworkEnum) {
    CurrencyNetworkEnum["arbitrum"] = "arbitrum";
    CurrencyNetworkEnum["base"] = "base";
    CurrencyNetworkEnum["bitcoin"] = "bitcoin";
    CurrencyNetworkEnum["bsc"] = "bsc";
    CurrencyNetworkEnum["cards"] = "cards";
    CurrencyNetworkEnum["cash"] = "cash";
    CurrencyNetworkEnum["dogecoin"] = "dogecoin";
    CurrencyNetworkEnum["ethereum"] = "ethereum";
    CurrencyNetworkEnum["fiat"] = "fiat";
    CurrencyNetworkEnum["interac"] = "interac";
    CurrencyNetworkEnum["lightning"] = "lightning";
    CurrencyNetworkEnum["litecoin"] = "litecoin";
    CurrencyNetworkEnum["manual"] = "manual";
    CurrencyNetworkEnum["near"] = "near";
    CurrencyNetworkEnum["nearintents"] = "nearintents";
    CurrencyNetworkEnum["optimism"] = "optimism";
    CurrencyNetworkEnum["other"] = "other";
    CurrencyNetworkEnum["polygon"] = "polygon";
    CurrencyNetworkEnum["solana"] = "solana";
    CurrencyNetworkEnum["tron"] = "tron";
})(CurrencyNetworkEnum || (CurrencyNetworkEnum = {}));
export var CurrencyNetworkToken;
(function (CurrencyNetworkToken) {
    CurrencyNetworkToken["bitcoinBtc"] = "bitcoinBtc";
    CurrencyNetworkToken["bscBnb"] = "bscBnb";
    CurrencyNetworkToken["bscUsdt"] = "bscUsdt";
    CurrencyNetworkToken["cardsBnb"] = "cardsBnb";
    CurrencyNetworkToken["cardsBtc"] = "cardsBtc";
    CurrencyNetworkToken["cardsDoge"] = "cardsDoge";
    CurrencyNetworkToken["cardsEth"] = "cardsEth";
    CurrencyNetworkToken["cardsLtc"] = "cardsLtc";
    CurrencyNetworkToken["cardsPol"] = "cardsPol";
    CurrencyNetworkToken["cardsTrx"] = "cardsTrx";
    CurrencyNetworkToken["cardsUsdc"] = "cardsUsdc";
    CurrencyNetworkToken["cardsUsdt"] = "cardsUsdt";
    CurrencyNetworkToken["dogecoinDoge"] = "dogecoinDoge";
    CurrencyNetworkToken["ethereumEth"] = "ethereumEth";
    CurrencyNetworkToken["ethereumUsdc"] = "ethereumUsdc";
    CurrencyNetworkToken["ethereumUsdt"] = "ethereumUsdt";
    CurrencyNetworkToken["fiatAud"] = "fiatAud";
    CurrencyNetworkToken["fiatCad"] = "fiatCad";
    CurrencyNetworkToken["fiatEur"] = "fiatEur";
    CurrencyNetworkToken["fiatGbp"] = "fiatGbp";
    CurrencyNetworkToken["fiatTry"] = "fiatTry";
    CurrencyNetworkToken["fiatUsd"] = "fiatUsd";
    CurrencyNetworkToken["litecoinLtc"] = "litecoinLtc";
    CurrencyNetworkToken["nearIntentsBtc"] = "nearIntentsBtc";
    CurrencyNetworkToken["nearIntentsDoge"] = "nearIntentsDoge";
    CurrencyNetworkToken["nearIntentsEth"] = "nearIntentsEth";
    CurrencyNetworkToken["nearIntentsLtc"] = "nearIntentsLtc";
    CurrencyNetworkToken["nearIntentsSol"] = "nearIntentsSol";
    CurrencyNetworkToken["nearIntentsTrx"] = "nearIntentsTrx";
    CurrencyNetworkToken["nearIntentsUsdc"] = "nearIntentsUsdc";
    CurrencyNetworkToken["nearIntentsUsdt"] = "nearIntentsUsdt";
    CurrencyNetworkToken["nearNear"] = "nearNear";
    CurrencyNetworkToken["other"] = "other";
    CurrencyNetworkToken["polygonPol"] = "polygonPol";
    CurrencyNetworkToken["polygonUsdc"] = "polygonUsdc";
    CurrencyNetworkToken["polygonUsdt"] = "polygonUsdt";
    CurrencyNetworkToken["solanaSol"] = "solanaSol";
    CurrencyNetworkToken["solanaUsdc"] = "solanaUsdc";
    CurrencyNetworkToken["solanaUsdt"] = "solanaUsdt";
    CurrencyNetworkToken["tronTrx"] = "tronTrx";
    CurrencyNetworkToken["tronUsdt"] = "tronUsdt";
})(CurrencyNetworkToken || (CurrencyNetworkToken = {}));
export var DataFieldEnum;
(function (DataFieldEnum) {
    DataFieldEnum["ADDRESS_CITY"] = "ADDRESS_CITY";
    DataFieldEnum["ADDRESS_COUNTRY"] = "ADDRESS_COUNTRY";
    DataFieldEnum["ADDRESS_LINE_1"] = "ADDRESS_LINE_1";
    DataFieldEnum["ADDRESS_LINE_2"] = "ADDRESS_LINE_2";
    DataFieldEnum["ADDRESS_LINE_3"] = "ADDRESS_LINE_3";
    DataFieldEnum["ADDRESS_POSTAL_CODE"] = "ADDRESS_POSTAL_CODE";
    DataFieldEnum["ADDRESS_STATE_PROVINCE"] = "ADDRESS_STATE_PROVINCE";
    DataFieldEnum["ADDRESS_UNIT_NUMBER"] = "ADDRESS_UNIT_NUMBER";
    DataFieldEnum["CITY_OF_BIRTH"] = "CITY_OF_BIRTH";
    DataFieldEnum["COUNTRY_OF_BIRTH"] = "COUNTRY_OF_BIRTH";
    DataFieldEnum["COUNTRY_OF_RESIDENCE"] = "COUNTRY_OF_RESIDENCE";
    DataFieldEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    DataFieldEnum["DAY_OF_BIRTH"] = "DAY_OF_BIRTH";
    DataFieldEnum["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    DataFieldEnum["GENDER"] = "GENDER";
    DataFieldEnum["GIVEN_NAMES"] = "GIVEN_NAMES";
    DataFieldEnum["IDENTITY_COUNTRY"] = "IDENTITY_COUNTRY";
    DataFieldEnum["IDENTITY_DOCUMENT"] = "IDENTITY_DOCUMENT";
    DataFieldEnum["IDENTITY_NUMBER"] = "IDENTITY_NUMBER";
    DataFieldEnum["MIDDLE_NAMES"] = "MIDDLE_NAMES";
    DataFieldEnum["MONTH_OF_BIRTH"] = "MONTH_OF_BIRTH";
    DataFieldEnum["NATIONALITY"] = "NATIONALITY";
    DataFieldEnum["NICKNAME"] = "NICKNAME";
    DataFieldEnum["PASSPORT"] = "PASSPORT";
    DataFieldEnum["PROVINCE_OF_BIRTH"] = "PROVINCE_OF_BIRTH";
    DataFieldEnum["SELFIE"] = "SELFIE";
    DataFieldEnum["SUR_NAMES"] = "SUR_NAMES";
    DataFieldEnum["TEL_COUNTRY_CODE"] = "TEL_COUNTRY_CODE";
    DataFieldEnum["TEL_PHONE_NUMBER"] = "TEL_PHONE_NUMBER";
    DataFieldEnum["TITLE"] = "TITLE";
    DataFieldEnum["YEAR_OF_BIRTH"] = "YEAR_OF_BIRTH";
})(DataFieldEnum || (DataFieldEnum = {}));
export var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["ANDROID"] = "ANDROID";
    DevicePlatform["ANDROID_PHONE"] = "ANDROID_PHONE";
    DevicePlatform["ANDROID_TABLET"] = "ANDROID_TABLET";
    DevicePlatform["ANY"] = "ANY";
    DevicePlatform["DESKTOP"] = "DESKTOP";
    DevicePlatform["I_OS"] = "I_OS";
    DevicePlatform["I_PAD"] = "I_PAD";
    DevicePlatform["I_PHONE"] = "I_PHONE";
    DevicePlatform["LINUX"] = "LINUX";
    DevicePlatform["MAC"] = "MAC";
    DevicePlatform["MOBILE"] = "MOBILE";
    DevicePlatform["NULL"] = "NULL";
    DevicePlatform["OTHER"] = "OTHER";
    DevicePlatform["WINDOWS"] = "WINDOWS";
})(DevicePlatform || (DevicePlatform = {}));
export var EntityType;
(function (EntityType) {
    EntityType["ADMIN_USER"] = "ADMIN_USER";
    EntityType["AFFILIATE"] = "AFFILIATE";
    EntityType["BALANCE"] = "BALANCE";
    EntityType["BONUS"] = "BONUS";
    EntityType["BONUS_CASHOUT"] = "BONUS_CASHOUT";
    EntityType["BONUS_CASH_IN"] = "BONUS_CASH_IN";
    EntityType["BRAND"] = "BRAND";
    EntityType["CAMPAIGN"] = "CAMPAIGN";
    EntityType["CASHBACK"] = "CASHBACK";
    EntityType["CRYPTO_ADDRESS"] = "CRYPTO_ADDRESS";
    EntityType["DEPOSIT"] = "DEPOSIT";
    EntityType["DEPOSIT_BONUS_CASH_IN"] = "DEPOSIT_BONUS_CASH_IN";
    EntityType["DEPOSIT_REVERSAL"] = "DEPOSIT_REVERSAL";
    EntityType["DEVICE"] = "DEVICE";
    EntityType["DOMAIN"] = "DOMAIN";
    EntityType["EMAIL"] = "EMAIL";
    EntityType["EXPIRATION"] = "EXPIRATION";
    EntityType["FINGERPRINT"] = "FINGERPRINT";
    EntityType["GAME"] = "GAME";
    EntityType["GAME_ACTIVITY"] = "GAME_ACTIVITY";
    EntityType["GAME_CODE"] = "GAME_CODE";
    EntityType["GAME_NAME_RULE"] = "GAME_NAME_RULE";
    EntityType["GAME_PLATFORM"] = "GAME_PLATFORM";
    EntityType["GAME_PROVIDER"] = "GAME_PROVIDER";
    EntityType["IMPORT"] = "IMPORT";
    EntityType["INFECTION"] = "INFECTION";
    EntityType["IP_ADDRESS"] = "IP_ADDRESS";
    EntityType["MODERATOR"] = "MODERATOR";
    EntityType["OTHER"] = "OTHER";
    EntityType["PHONE"] = "PHONE";
    EntityType["PLAYER"] = "PLAYER";
    EntityType["PLAYERS"] = "PLAYERS";
    EntityType["PLAYER_DEPOSITED"] = "PLAYER_DEPOSITED";
    EntityType["PLAYER_NON_DEPOSITED"] = "PLAYER_NON_DEPOSITED";
    EntityType["PLAYER_TEST"] = "PLAYER_TEST";
    EntityType["PLAYER_VIP"] = "PLAYER_VIP";
    EntityType["REWARD"] = "REWARD";
    EntityType["SUBBRAND"] = "SUBBRAND";
    EntityType["SYSTEM"] = "SYSTEM";
    EntityType["TASK"] = "TASK";
    EntityType["TELEGRAM"] = "TELEGRAM";
    EntityType["THIRD_PARTY"] = "THIRD_PARTY";
    EntityType["TIP"] = "TIP";
    EntityType["TIP_COMP_PLAYER"] = "TIP_COMP_PLAYER";
    EntityType["TIP_COMP_SELF"] = "TIP_COMP_SELF";
    EntityType["WALLET"] = "WALLET";
    EntityType["WITHDRAWAL"] = "WITHDRAWAL";
    EntityType["WITHDRAWAL_REQUEST"] = "WITHDRAWAL_REQUEST";
    EntityType["WITHDRAWAL_REVERSAL"] = "WITHDRAWAL_REVERSAL";
})(EntityType || (EntityType = {}));
export var FiatCurrency;
(function (FiatCurrency) {
    FiatCurrency["AUD"] = "AUD";
    FiatCurrency["CAD"] = "CAD";
    FiatCurrency["EUR"] = "EUR";
    FiatCurrency["GBP"] = "GBP";
    FiatCurrency["JPY"] = "JPY";
    FiatCurrency["TRY"] = "TRY";
    FiatCurrency["USD"] = "USD";
})(FiatCurrency || (FiatCurrency = {}));
export var FreebetType;
(function (FreebetType) {
    FreebetType["BUY_FEATURE"] = "BUY_FEATURE";
    FreebetType["POWER_BET"] = "POWER_BET";
    FreebetType["REGULAR"] = "REGULAR";
    FreebetType["SPIN_ONLY_WIN"] = "SPIN_ONLY_WIN";
    FreebetType["SPIN_UNTIL_YOU_WIN"] = "SPIN_UNTIL_YOU_WIN";
})(FreebetType || (FreebetType = {}));
export var GamePlatform;
(function (GamePlatform) {
    GamePlatform["GAME_TECH"] = "GAME_TECH";
    GamePlatform["ORIGINALS"] = "ORIGINALS";
    GamePlatform["SOFT_GAMING"] = "SOFT_GAMING";
})(GamePlatform || (GamePlatform = {}));
export var GameStatus;
(function (GameStatus) {
    GameStatus["ACTIVE"] = "ACTIVE";
    GameStatus["DEPRECATED"] = "DEPRECATED";
    GameStatus["DISABLED"] = "DISABLED";
    GameStatus["HIDDEN"] = "HIDDEN";
    GameStatus["INACTIVE"] = "INACTIVE";
    GameStatus["MAINTENANCE"] = "MAINTENANCE";
    GameStatus["NEW"] = "NEW";
    GameStatus["NOT_FOUND"] = "NOT_FOUND";
    GameStatus["NULL"] = "NULL";
})(GameStatus || (GameStatus = {}));
export var Language;
(function (Language) {
    Language["AA"] = "AA";
    Language["AB"] = "AB";
    Language["AE"] = "AE";
    Language["AF"] = "AF";
    Language["AK"] = "AK";
    Language["AM"] = "AM";
    Language["AN"] = "AN";
    Language["AR"] = "AR";
    Language["AS"] = "AS";
    Language["AV"] = "AV";
    Language["AY"] = "AY";
    Language["AZ"] = "AZ";
    Language["BA"] = "BA";
    Language["BE"] = "BE";
    Language["BG"] = "BG";
    Language["BH"] = "BH";
    Language["BI"] = "BI";
    Language["BM"] = "BM";
    Language["BN"] = "BN";
    Language["BO"] = "BO";
    Language["BR"] = "BR";
    Language["BS"] = "BS";
    Language["CA"] = "CA";
    Language["CE"] = "CE";
    Language["CH"] = "CH";
    Language["CO"] = "CO";
    Language["CR"] = "CR";
    Language["CS"] = "CS";
    Language["CU"] = "CU";
    Language["CV"] = "CV";
    Language["CY"] = "CY";
    Language["DA"] = "DA";
    Language["DE"] = "DE";
    Language["DV"] = "DV";
    Language["DZ"] = "DZ";
    Language["EE"] = "EE";
    Language["EL"] = "EL";
    Language["EN"] = "EN";
    Language["EO"] = "EO";
    Language["ES"] = "ES";
    Language["ET"] = "ET";
    Language["EU"] = "EU";
    Language["FA"] = "FA";
    Language["FF"] = "FF";
    Language["FI"] = "FI";
    Language["FJ"] = "FJ";
    Language["FO"] = "FO";
    Language["FR"] = "FR";
    Language["FY"] = "FY";
    Language["GA"] = "GA";
    Language["GD"] = "GD";
    Language["GL"] = "GL";
    Language["GN"] = "GN";
    Language["GU"] = "GU";
    Language["GV"] = "GV";
    Language["HA"] = "HA";
    Language["HE"] = "HE";
    Language["HI"] = "HI";
    Language["HO"] = "HO";
    Language["HR"] = "HR";
    Language["HT"] = "HT";
    Language["HU"] = "HU";
    Language["HY"] = "HY";
    Language["HZ"] = "HZ";
    Language["IA"] = "IA";
    Language["ID"] = "ID";
    Language["IE"] = "IE";
    Language["IG"] = "IG";
    Language["II"] = "II";
    Language["IK"] = "IK";
    Language["IO"] = "IO";
    Language["IS"] = "IS";
    Language["IT"] = "IT";
    Language["IU"] = "IU";
    Language["JA"] = "JA";
    Language["JV"] = "JV";
    Language["KA"] = "KA";
    Language["KG"] = "KG";
    Language["KI"] = "KI";
    Language["KJ"] = "KJ";
    Language["KK"] = "KK";
    Language["KL"] = "KL";
    Language["KM"] = "KM";
    Language["KN"] = "KN";
    Language["KO"] = "KO";
    Language["KR"] = "KR";
    Language["KS"] = "KS";
    Language["KU"] = "KU";
    Language["KV"] = "KV";
    Language["KW"] = "KW";
    Language["KY"] = "KY";
    Language["LA"] = "LA";
    Language["LB"] = "LB";
    Language["LG"] = "LG";
    Language["LI"] = "LI";
    Language["LN"] = "LN";
    Language["LO"] = "LO";
    Language["LT"] = "LT";
    Language["LU"] = "LU";
    Language["LV"] = "LV";
    Language["MG"] = "MG";
    Language["MH"] = "MH";
    Language["MI"] = "MI";
    Language["MK"] = "MK";
    Language["ML"] = "ML";
    Language["MN"] = "MN";
    Language["MR"] = "MR";
    Language["MS"] = "MS";
    Language["MT"] = "MT";
    Language["MY"] = "MY";
    Language["NA"] = "NA";
    Language["NB"] = "NB";
    Language["ND"] = "ND";
    Language["NE"] = "NE";
    Language["NG"] = "NG";
    Language["NL"] = "NL";
    Language["NN"] = "NN";
    Language["NO"] = "NO";
    Language["NR"] = "NR";
    Language["NV"] = "NV";
    Language["NY"] = "NY";
    Language["OC"] = "OC";
    Language["OJ"] = "OJ";
    Language["OM"] = "OM";
    Language["OR"] = "OR";
    Language["OS"] = "OS";
    Language["PA"] = "PA";
    Language["PI"] = "PI";
    Language["PL"] = "PL";
    Language["PS"] = "PS";
    Language["PT"] = "PT";
    Language["QU"] = "QU";
    Language["RM"] = "RM";
    Language["RN"] = "RN";
    Language["RO"] = "RO";
    Language["RU"] = "RU";
    Language["RW"] = "RW";
    Language["SA"] = "SA";
    Language["SC"] = "SC";
    Language["SD"] = "SD";
    Language["SE"] = "SE";
    Language["SG"] = "SG";
    Language["SI"] = "SI";
    Language["SK"] = "SK";
    Language["SL"] = "SL";
    Language["SM"] = "SM";
    Language["SN"] = "SN";
    Language["SO"] = "SO";
    Language["SQ"] = "SQ";
    Language["SR"] = "SR";
    Language["SS"] = "SS";
    Language["ST"] = "ST";
    Language["SU"] = "SU";
    Language["SV"] = "SV";
    Language["SW"] = "SW";
    Language["TA"] = "TA";
    Language["TE"] = "TE";
    Language["TG"] = "TG";
    Language["TH"] = "TH";
    Language["TI"] = "TI";
    Language["TK"] = "TK";
    Language["TL"] = "TL";
    Language["TN"] = "TN";
    Language["TO"] = "TO";
    Language["TR"] = "TR";
    Language["TS"] = "TS";
    Language["TT"] = "TT";
    Language["TW"] = "TW";
    Language["TY"] = "TY";
    Language["UG"] = "UG";
    Language["UK"] = "UK";
    Language["UR"] = "UR";
    Language["UZ"] = "UZ";
    Language["VE"] = "VE";
    Language["VI"] = "VI";
    Language["VO"] = "VO";
    Language["WA"] = "WA";
    Language["WO"] = "WO";
    Language["XH"] = "XH";
    Language["YI"] = "YI";
    Language["YO"] = "YO";
    Language["ZA"] = "ZA";
    Language["ZH"] = "ZH";
    Language["ZU"] = "ZU";
})(Language || (Language = {}));
export var OddsFormat;
(function (OddsFormat) {
    OddsFormat["AMERICAN"] = "AMERICAN";
    OddsFormat["DECIMAL"] = "DECIMAL";
    OddsFormat["FRACTIONAL"] = "FRACTIONAL";
    OddsFormat["HONGKONG"] = "HONGKONG";
    OddsFormat["INDONESIAN"] = "INDONESIAN";
    OddsFormat["MALAYSIAN"] = "MALAYSIAN";
})(OddsFormat || (OddsFormat = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["bank"] = "bank";
    PaymentMethod["card"] = "card";
    PaymentMethod["other"] = "other";
})(PaymentMethod || (PaymentMethod = {}));
export var PlayerType;
(function (PlayerType) {
    PlayerType["ADMIN"] = "ADMIN";
    PlayerType["ADMIN_CASHIER"] = "ADMIN_CASHIER";
    PlayerType["AFFILIATE"] = "AFFILIATE";
    PlayerType["AFFILIATE_MANAGER"] = "AFFILIATE_MANAGER";
    PlayerType["MODERATOR"] = "MODERATOR";
    PlayerType["REGULAR"] = "REGULAR";
    PlayerType["STREAMER"] = "STREAMER";
    PlayerType["SUPPORT"] = "SUPPORT";
    PlayerType["TEST"] = "TEST";
    PlayerType["TEST_CASHIER"] = "TEST_CASHIER";
})(PlayerType || (PlayerType = {}));
export var RewardType;
(function (RewardType) {
    RewardType["AD_HOC"] = "AD_HOC";
    RewardType["BESPOKE"] = "BESPOKE";
    RewardType["CALENDAR"] = "CALENDAR";
    RewardType["CAMPAIGN"] = "CAMPAIGN";
    RewardType["CASHBACK"] = "CASHBACK";
    RewardType["CASHBACK_DAILY"] = "CASHBACK_DAILY";
    RewardType["CASHBACK_INSTANT"] = "CASHBACK_INSTANT";
    RewardType["CASHBACK_MONTHLY"] = "CASHBACK_MONTHLY";
    RewardType["CASHBACK_WEEKLY"] = "CASHBACK_WEEKLY";
    RewardType["COMP"] = "COMP";
    RewardType["FREEBET"] = "FREEBET";
    RewardType["LEVEL_UP"] = "LEVEL_UP";
    RewardType["NEW_PLAYER"] = "NEW_PLAYER";
    RewardType["OTHER"] = "OTHER";
    RewardType["QUEST"] = "QUEST";
    RewardType["RACE"] = "RACE";
    RewardType["RACE_WEEKLY"] = "RACE_WEEKLY";
    RewardType["RAKEBACK"] = "RAKEBACK";
    RewardType["RAKEBOOST"] = "RAKEBOOST";
    RewardType["REFERRAL"] = "REFERRAL";
    RewardType["RESET_CASHBACK_INSTANT"] = "RESET_CASHBACK_INSTANT";
})(RewardType || (RewardType = {}));
export var Role;
(function (Role) {
    Role["ANY"] = "ANY";
    Role["MODERATOR"] = "MODERATOR";
    Role["NONE"] = "NONE";
    Role["STAFF"] = "STAFF";
    Role["TEST_USER"] = "TEST_USER";
    Role["USER"] = "USER";
})(Role || (Role = {}));
export var SimpleStatus;
(function (SimpleStatus) {
    SimpleStatus["ACTIVE"] = "ACTIVE";
    SimpleStatus["DISABLED"] = "DISABLED";
    SimpleStatus["INACTIVE"] = "INACTIVE";
    SimpleStatus["NEW"] = "NEW";
    SimpleStatus["NOT_FOUND"] = "NOT_FOUND";
    SimpleStatus["NULL"] = "NULL";
    SimpleStatus["OTHER"] = "OTHER";
})(SimpleStatus || (SimpleStatus = {}));
export var Stage;
(function (Stage) {
    Stage["DEV"] = "DEV";
    Stage["LOCAL"] = "LOCAL";
    Stage["PRODUCTION"] = "PRODUCTION";
    Stage["STAGING"] = "STAGING";
    Stage["TEST"] = "TEST";
})(Stage || (Stage = {}));
export var Status;
(function (Status) {
    Status["ACCEPTED"] = "ACCEPTED";
    Status["APPROVED"] = "APPROVED";
    Status["AVAILABLE"] = "AVAILABLE";
    Status["BACKFILLING"] = "BACKFILLING";
    Status["BAD_PARAMS"] = "BAD_PARAMS";
    Status["COMPLETED"] = "COMPLETED";
    Status["CONFIRMED"] = "CONFIRMED";
    Status["CONFLICT"] = "CONFLICT";
    Status["CONNECT_FAILED"] = "CONNECT_FAILED";
    Status["COUNTRY_CODE_NOT_SUPPORTED"] = "COUNTRY_CODE_NOT_SUPPORTED";
    Status["CREATED"] = "CREATED";
    Status["CURRENCY_NOT_SUPPORTED"] = "CURRENCY_NOT_SUPPORTED";
    Status["DISABLED"] = "DISABLED";
    Status["DUPLICATE"] = "DUPLICATE";
    Status["EXPIRED"] = "EXPIRED";
    Status["FAILED"] = "FAILED";
    Status["FATAL_ERROR"] = "FATAL_ERROR";
    Status["FORBIDDEN"] = "FORBIDDEN";
    Status["FOUND"] = "FOUND";
    Status["INACTIVE"] = "INACTIVE";
    Status["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    Status["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    Status["LANGUAGE_NOT_SUPPORTED"] = "LANGUAGE_NOT_SUPPORTED";
    Status["MAINTENANCE"] = "MAINTENANCE";
    Status["MAX_AMOUNT"] = "MAX_AMOUNT";
    Status["MAX_PLAYERS"] = "MAX_PLAYERS";
    Status["MAX_RETRIES"] = "MAX_RETRIES";
    Status["MAX_REWARDS"] = "MAX_REWARDS";
    Status["MIN_AMOUNT"] = "MIN_AMOUNT";
    Status["MISSING"] = "MISSING";
    Status["MODIFIED"] = "MODIFIED";
    Status["NOT_FOUND"] = "NOT_FOUND";
    Status["NOT_FOUND_2"] = "NOT_FOUND_2";
    Status["NOT_MODIFIED"] = "NOT_MODIFIED";
    Status["NOT_READY"] = "NOT_READY";
    Status["NOT_STARTED"] = "NOT_STARTED";
    Status["NO_SESSION"] = "NO_SESSION";
    Status["NO_UPDATES"] = "NO_UPDATES";
    Status["NULL"] = "NULL";
    Status["OK"] = "OK";
    Status["OTHER"] = "OTHER";
    Status["PAUSED"] = "PAUSED";
    Status["PENDING"] = "PENDING";
    Status["PRECONDITION_2_FAILED"] = "PRECONDITION_2_FAILED";
    Status["PRECONDITION_3_FAILED"] = "PRECONDITION_3_FAILED";
    Status["PRECONDITION_4_FAILED"] = "PRECONDITION_4_FAILED";
    Status["PRECONDITION_FAILED"] = "PRECONDITION_FAILED";
    Status["PROCESSING"] = "PROCESSING";
    Status["READY"] = "READY";
    Status["REQUESTED"] = "REQUESTED";
    Status["REQUIRED"] = "REQUIRED";
    Status["REQUIRED_PARAMS"] = "REQUIRED_PARAMS";
    Status["RESOLVE_FAILED"] = "RESOLVE_FAILED";
    Status["RETRYING"] = "RETRYING";
    Status["SUCCESS"] = "SUCCESS";
    Status["TIMEOUT"] = "TIMEOUT";
    Status["TOO_MANY_ATTEMPTS"] = "TOO_MANY_ATTEMPTS";
    Status["UNAUTHORIZED"] = "UNAUTHORIZED";
    Status["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
    Status["UNRESOLVED"] = "UNRESOLVED";
    Status["UPDATED"] = "UPDATED";
    Status["WRONG_CURRENCY"] = "WRONG_CURRENCY";
})(Status || (Status = {}));
export var SystemStatus;
(function (SystemStatus) {
    SystemStatus["ACTIVE"] = "ACTIVE";
    SystemStatus["ARCHIVED"] = "ARCHIVED";
    SystemStatus["COMING_SOON"] = "COMING_SOON";
    SystemStatus["DISABLED"] = "DISABLED";
    SystemStatus["HOLD"] = "HOLD";
    SystemStatus["INACTIVE"] = "INACTIVE";
    SystemStatus["MAINTENANCE"] = "MAINTENANCE";
    SystemStatus["MANUAL"] = "MANUAL";
    SystemStatus["NEW"] = "NEW";
    SystemStatus["NOT_FOUND"] = "NOT_FOUND";
    SystemStatus["OTHER"] = "OTHER";
    SystemStatus["PREVIEW"] = "PREVIEW";
    SystemStatus["RESTRICTED"] = "RESTRICTED";
})(SystemStatus || (SystemStatus = {}));
export var TemporalStatus;
(function (TemporalStatus) {
    TemporalStatus["NONE"] = "NONE";
    TemporalStatus["PERMANENT"] = "PERMANENT";
    TemporalStatus["TEMPORARY"] = "TEMPORARY";
    TemporalStatus["UNTIL_APPROVED"] = "UNTIL_APPROVED";
    TemporalStatus["UNTIL_MAINTENANCE_COMPLETE"] = "UNTIL_MAINTENANCE_COMPLETE";
    TemporalStatus["UNTIL_REQUIREMENTS_MET"] = "UNTIL_REQUIREMENTS_MET";
    TemporalStatus["UNTIL_TIME_ELAPSED"] = "UNTIL_TIME_ELAPSED";
})(TemporalStatus || (TemporalStatus = {}));
export var TxStatus;
(function (TxStatus) {
    TxStatus["ACCEPTING"] = "ACCEPTING";
    TxStatus["APPROVING"] = "APPROVING";
    TxStatus["CANCELLED"] = "CANCELLED";
    TxStatus["CANCELLING"] = "CANCELLING";
    TxStatus["COMPLETED"] = "COMPLETED";
    TxStatus["CONFIRMED"] = "CONFIRMED";
    TxStatus["CONFIRMING"] = "CONFIRMING";
    TxStatus["CREDITED"] = "CREDITED";
    TxStatus["EXPIRED"] = "EXPIRED";
    TxStatus["FAILED"] = "FAILED";
    TxStatus["HOLD"] = "HOLD";
    TxStatus["NOT_FOUND"] = "NOT_FOUND";
    TxStatus["OTHER"] = "OTHER";
    TxStatus["PENDING"] = "PENDING";
    TxStatus["PROCESSING"] = "PROCESSING";
    TxStatus["READY"] = "READY";
    TxStatus["REJECTED"] = "REJECTED";
    TxStatus["REQUESTED"] = "REQUESTED";
    TxStatus["RETURNED"] = "RETURNED";
    TxStatus["RETURNING"] = "RETURNING";
    TxStatus["REVERSED"] = "REVERSED";
    TxStatus["REVIEWING"] = "REVIEWING";
    TxStatus["SUCCEEDED"] = "SUCCEEDED";
})(TxStatus || (TxStatus = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ABUSE_BAN"] = "ABUSE_BAN";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["ADMIN_BAN"] = "ADMIN_BAN";
    UserStatus["BANNED"] = "BANNED";
    UserStatus["BLACKLIST"] = "BLACKLIST";
    UserStatus["DELETED"] = "DELETED";
    UserStatus["DISABLED"] = "DISABLED";
    UserStatus["GEO_BAN"] = "GEO_BAN";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["LOGGED_OUT"] = "LOGGED_OUT";
    UserStatus["NOT_FOUND"] = "NOT_FOUND";
    UserStatus["NULL"] = "NULL";
    UserStatus["OTHER"] = "OTHER";
    UserStatus["PLAYER_BAN"] = "PLAYER_BAN";
    UserStatus["REQUESTED"] = "REQUESTED";
    UserStatus["SOFT_BAN"] = "SOFT_BAN";
    UserStatus["SUSPENDED"] = "SUSPENDED";
    UserStatus["SYSTEM_BAN"] = "SYSTEM_BAN";
    UserStatus["TERMINATED"] = "TERMINATED";
    UserStatus["WHITELIST"] = "WHITELIST";
})(UserStatus || (UserStatus = {}));
export var Vendor;
(function (Vendor) {
    Vendor["affilka"] = "affilka";
    Vendor["bitblaze"] = "bitblaze";
    Vendor["cubePay"] = "cubePay";
    Vendor["onRampLTD"] = "onRampLTD";
    Vendor["onRamper"] = "onRamper";
    Vendor["other"] = "other";
})(Vendor || (Vendor = {}));
export var Visibility;
(function (Visibility) {
    Visibility["HIDDEN"] = "HIDDEN";
    Visibility["INTERNAL"] = "INTERNAL";
    Visibility["OTHER"] = "OTHER";
    Visibility["PRIVATE"] = "PRIVATE";
    Visibility["PROMOTED"] = "PROMOTED";
    Visibility["PUBLIC"] = "PUBLIC";
})(Visibility || (Visibility = {}));
export var WithdrawAmountType;
(function (WithdrawAmountType) {
    WithdrawAmountType["CRYPTO"] = "CRYPTO";
    WithdrawAmountType["FIAT"] = "FIAT";
    WithdrawAmountType["HALF"] = "HALF";
    WithdrawAmountType["MAX"] = "MAX";
    WithdrawAmountType["MIN"] = "MIN";
    WithdrawAmountType["OTHER"] = "OTHER";
    WithdrawAmountType["QUARTER"] = "QUARTER";
    WithdrawAmountType["THREE_QUARTERS"] = "THREE_QUARTERS";
})(WithdrawAmountType || (WithdrawAmountType = {}));
export var WithdrawEligibility;
(function (WithdrawEligibility) {
    WithdrawEligibility["BANNED"] = "BANNED";
    WithdrawEligibility["BONUS_LOCK"] = "BONUS_LOCK";
    WithdrawEligibility["CANCELLED"] = "CANCELLED";
    WithdrawEligibility["CANCEL_BONUS"] = "CANCEL_BONUS";
    WithdrawEligibility["CASHED_OUT"] = "CASHED_OUT";
    WithdrawEligibility["CASHOUT_PENDING"] = "CASHOUT_PENDING";
    WithdrawEligibility["CASH_OUT_EARNED"] = "CASH_OUT_EARNED";
    WithdrawEligibility["CASH_OUT_FORFEIT"] = "CASH_OUT_FORFEIT";
    WithdrawEligibility["DAILY_LIMIT"] = "DAILY_LIMIT";
    WithdrawEligibility["ELIGIBLE"] = "ELIGIBLE";
    WithdrawEligibility["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    WithdrawEligibility["EXCEEDS_BALANCE"] = "EXCEEDS_BALANCE";
    WithdrawEligibility["EXPIRED"] = "EXPIRED";
    WithdrawEligibility["INELIGIBLE"] = "INELIGIBLE";
    WithdrawEligibility["MONTHLY_LIMIT"] = "MONTHLY_LIMIT";
    WithdrawEligibility["OTHER"] = "OTHER";
    WithdrawEligibility["OVER_MAXIMUM"] = "OVER_MAXIMUM";
    WithdrawEligibility["PLAYER_WALLET"] = "PLAYER_WALLET";
    WithdrawEligibility["PLAY_REQUIREMENT"] = "PLAY_REQUIREMENT";
    WithdrawEligibility["ROLLOVER_REQUIRED"] = "ROLLOVER_REQUIRED";
    WithdrawEligibility["SELF_WALLET"] = "SELF_WALLET";
    WithdrawEligibility["UNDER_MINIMUM"] = "UNDER_MINIMUM";
    WithdrawEligibility["WEEKLY_LIMIT"] = "WEEKLY_LIMIT";
    WithdrawEligibility["WITHDRAWALS_FROZEN"] = "WITHDRAWALS_FROZEN";
})(WithdrawEligibility || (WithdrawEligibility = {}));
export const AuthCheckDoc = gql `
	query AuthCheck {
		authcheck {
			id
			username
		}
	}
`;
export const StartBetbySessionDoc = gql `
	mutation StartBetbySession($params: BetbyStartSessionParams!) {
		startBetbySession(params: $params) {
			status
			sessionStatus
			betbySessionId
			token
		}
	}
`;
export const AuthCheck = makeQueryStore(AuthCheckDoc);
export const AsyncAuthCheck = makeAsyncQuery(AuthCheckDoc);
export const StartBetbySession = makeMutation(StartBetbySessionDoc);
